import { flavors } from '../../config'

export function getPageFlavor(conferenceYear) {
  const currentYear = new Date().getFullYear()
  const year = conferenceYear ? parseInt(conferenceYear, 10) : null
  return year === currentYear ? 'dusk' : flavors.default
}

export function getCustomPageFlavor(color) {
  const keys = Object.keys(flavors)
  const flavor = keys?.find((key) => flavors[key].solid === color) || ''

  return flavor
}
